if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    connectedCallback() {
      this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.handleErrorMessage());
      const scope = this.closest('.product__info-container');
      if (!scope || !this.dataset.stackHelp) return;
      const placeHelp = () => {
        scope.querySelectorAll('.po-heading-root').forEach((heading) => {
          if (heading.querySelector('.trt-stack-help')) return;
          const help = document.createElement('p');
          help.className = 'trt-stack-help';
          help.textContent = this.dataset.stackHelp;
          heading.append(help);
        });
      };
      placeHelp();
      this.stackHelpObserver = new MutationObserver(placeHelp);
      this.stackHelpObserver.observe(scope, { childList: true, subtree: true });
      this.querySelector('[data-view-cart]')?.addEventListener('click', (event) => {
        if (typeof this.cart?.open !== 'function') return;
        event.preventDefault();
        this.cart.open(event.currentTarget);
      });
    }

    disconnectedCallback() {
      this.stackHelpObserver?.disconnect();
      this.unsubscribeCartUpdate?.();
    }

    stockLimitMessage(message, variantId) {
      if (message !== 'The maximum quantity of this item is already in your cart.' ||
          !this.dataset.stockLimitMessage || !this.closest('.product__info-container')?.querySelector('.po-heading-root')) return message;
      const rows = Array.from(this.cart?.querySelectorAll('[data-cart-variant-id]') || [])
        .filter((row) => row.dataset.cartVariantId === String(variantId));
      const quantity = rows.reduce((sum, row) => sum + Number(row.dataset.cartVariantQuantity || 0), 0);
      const limit = rows.find((row) => row.dataset.cartVariantLimited === 'true')?.dataset.cartVariantLimit;
      return limit !== undefined && quantity > 0 && quantity >= Number(limit) ? this.dataset.stockLimitMessage : message;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.error = false;
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const hasSelectedAddons = Boolean(this.closest('.product__info-container')?.querySelector('.po-checkboxOption-checkbox:checked'));
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.error = true;
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            const message = response.description || response.message;
            this.handleErrorMessage(message);

            if (this.cart && typeof this.cart.refreshContents === 'function') {
              return this.cart.refreshContents()
                .then(() => {
                  const stackStockError = hasSelectedAddons && this.dataset.stackStockMessage &&
                    /^The product '.+' is already sold out\.$/i.test(message || '');
                  const displayMessage = stackStockError ? this.dataset.stackStockMessage : this.stockLimitMessage(message, formData.get('id'));
                  this.handleErrorMessage(displayMessage, !stackStockError || !this.cart.classList.contains('is-empty'));
                  const partialAdd = /^Only [1-9]\d* items? (?:was|were) added to your cart(?: due to availability)?\.$/i.test(message || '');
                  if (partialAdd) {
                    this.cart.showStockNotice(message);
                    this.cart.open(this.submitButton);
                  }
                  return this.closest('product-info')?.fetchQuantityRules();
                })
                .catch((error) => {
                  console.error(error);
                  window.location = window.routes.cart_url;
                });
            }
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          this.error = true;
          this.handleErrorMessage("We couldn't confirm your cart update. Please check your cart before trying again.");
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          // Preserve the current empty state when adding to the cart fails.
          if (!this.error && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false, showViewCart = true) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      const viewCart = this.querySelector('[data-view-cart]');
      if (viewCart) viewCart.hidden = !errorMessage || !showViewCart;

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


